module.exports = __webpack_public_path__ + "img/Doc12a_20110057-009.eb5522b8.jpg";